module.exports = __webpack_public_path__ + "img/ch21_09_记忆碎片.3399cc0b.jpg";